<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stockinout" />
        <MenuStockList/>
        <AddLotinList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import AddLotinList from '@/components/menuadmin/stock/stocklist/AddLotinList.vue'

export default {
    name:'addLotin',
    components:{
        HeaderStock,
        MenuStockList,
        AddLotinList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>